import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Container, Card, Button, ListGroup, Badge } from "react-bootstrap";
import { useLanguage } from "../../../../API/Context/LanguageContext";
import { useDashboardPreference } from "../../../../API/Context/AppUIContext";
import { SUCCESS_FLOWS } from "../../../../ConfigFiles/content/onboarding_sucess_flows";
import { VocabOnboardingSuccess as Vocab } from "../../../../ConfigFiles/multilingual/VocabOnboardingSuccess";
import { FRONTEND_ROUTES } from "../../../../ConfigFiles/Routes/frontend_routes.js";

const OnboardingSuccess = () => {
    const { lan } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const { togglePreference } = useDashboardPreference();
    
    const [countdown, setCountdown] = useState(8000000); // 8 seconds auto-redirect
    const flowType = location.state?.flow || "PURE_PROFESSIONAL";//"PURE_PATIENT";
    const config = SUCCESS_FLOWS[flowType];

    const handleFinalStep = () => {
        if (flowType === "PRO_TO_PATIENT") togglePreference(false);
        else if (flowType === "PURE_PROFESSIONAL" || flowType === "PATIENT_TO_PRO") togglePreference(true);
        navigate(config.redirectTo, { replace: true });
    };

    // Auto-redirect logic
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        if (countdown === 0) handleFinalStep();

        return () => clearInterval(timer);
    }, [countdown]);

    return (
        <Container className="d-flex align-items-center justify-content-center vh-100 bg-light">
            <Card className="text-center shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: "480px" }}>
                <div className={`${config.isPending ? 'bg-warning' : 'bg-primary'} py-4 text-white shadow`}>
                    <i className={`bi bi-${config.icon}`} style={{ fontSize: "3.5rem" }}></i>
                    <h2 className="fw-bold mt-2">{Vocab[config.title][lan]}</h2>
                </div>
                
                <Card.Body className="p-4 p-md-5">
                    {config.isPending ? (
                        <div className="mb-4">
                            <Badge bg="warning" text="dark" className="mb-3 px-3 py-2 rounded-pill">
                                <i className="bi bi-clock-history me-2"></i>
                                {Vocab.estimated_wait[lan]} {config.estimatedTime}
                            </Badge>
                            <p className="text-muted small">
                                {Vocab[config.statusKey][lan]}
                            </p>
                        </div>
                    ) : null}

                    <ListGroup variant="flush" className="text-start mb-4">
                        {config.features.map((feat, idx) => (
                            <ListGroup.Item key={idx} className="border-0 px-0 d-flex align-items-center">
                                <i className={`bi ${config.isPending ? 'bi-hourglass-split text-warning' : 'bi-check-circle-fill text-success'} me-3`}></i>
                                <span className="text-secondary small">{Vocab[feat][lan]}</span>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>

                    <Button variant="primary" size="lg" className="w-100 rounded-pill mb-3 shadow-sm" onClick={handleFinalStep}>
                        {Vocab[config.primaryAction][lan]}
                    </Button>

                    {/* 🎯 Auto-redirect ONLY for patients. Medics should stay and read the status. */}
                    {!config.isPending && (
                        <div className="text-muted small">
                            {Vocab.redirect_notice[lan]} <strong>{countdown}</strong> {Vocab.seconds[lan]}...
                        </div>
                    )}
                </Card.Body>

                <Card.Footer className="bg-white border-top-0 pb-4">
                    <p className="text-muted small mb-2">{Vocab.social_legend[lan]}</p>
                    <Link to={FRONTEND_ROUTES.socials} className="text-decoration-none fw-bold">
                        <i className="bi bi-instagram me-1"></i>
                        <i className="bi bi-facebook me-1"></i>
                        <i className="bi bi-linkedin me-1"></i>
                        @MedCleir
                    </Link>
                </Card.Footer>
            </Card>
        </Container>
    );
};

export default OnboardingSuccess;